import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import { MercadoInternoClassificacaoService } from './mercado-interno-classificacao.service';
import { MercadoInternoMercadoriasService } from './mercado-interno-mercadorias.service';
import { MercadoInternoDefeitosService } from './mercado-interno-defeitos.service';
import { Funcoes } from "../funcoes";
import { Global } from "../global";

@Component({
  selector: 'app-mercado-interno-classificacao-form',
  templateUrl: './mercado-interno-classificacao-form.component.html'
})
export class MercadoInternoClassificacaoFormComponent implements OnInit {

  enviandoForm = false;
  form: FormGroup;
  title: string;
  classificacao: any = {};
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  listMercadorias = [];
  listDefeitos = [];

  listCores = [
    { 'valor': 0, 'nome': 'Vermelho' },
    { 'valor': 1, 'nome': 'Verde' },
    { 'valor': 2, 'nome': 'Amarelo' }
  ];

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private mercadoriasClassificacaoService: MercadoInternoClassificacaoService,
    private mercadoriasService: MercadoInternoMercadoriasService,
    private mercadoriasDefeitosService: MercadoInternoDefeitosService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      id_mercadoria: ['', [
        Validators.required,
        BasicValidators.diferenteZero
      ]],
      id_defeito: ['', [
        Validators.required,
        BasicValidators.diferenteZero
      ]],
      nome: ['', [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(45)
      ]],
      percentual: ['', [
        Validators.required
      ]],
      percentual_tipo: [],
      cor: []
    });
  }

  ngOnInit() {
    const urlPath = this.router.url.split('?')[0];
    const lastSegment = urlPath.split(/\//).pop();

    if (lastSegment == 'upd') {
      this.pageIsUpd = true;
    }

    if (lastSegment == 'add') {
      this.pageIsAdd = true;
    }

    this.mercadoriasService.get()
      .subscribe(
        json => {
          this.listMercadorias = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });

    this.route.params.subscribe(params => {
      let id = params['id_classificacao'];

      if (!this.pageIsUpd) {
        this.title = this.func.traduzir('front.editarIndiceClassificacao');
      } else {
        this.title = id ? this.func.traduzir('front.visualizarIndiceClassificacao') : this.func.traduzir('front.cadastrarNovoIndiceClassificacao');
      }

      if (!id) {
        if (this.route.snapshot.queryParams["mercadoria"]) {
          this.classificacao.id_mercadoria = this.route.snapshot.queryParams["mercadoria"];
          this.changeMercadoria();
        }
        if (this.route.snapshot.queryParams["defeito"]) {
          this.classificacao.id_defeito = this.route.snapshot.queryParams["defeito"];
        }
        return;
      }

      this.mercadoriasClassificacaoService.getById(id)
        .subscribe(
          json => {
            if (this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarIndiceClassificacao') + ': ' + json.Payload[0].nome;
            } else {
              this.title = this.func.traduzir('front.visualizarIndiceClassificacao') + ': ' + json.Payload[0].nome;
            }
            this.classificacao = json.Payload[0];
            this.changeMercadoria();
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  changeMercadoria() {
    if (this.classificacao.id_mercadoria) {
      this.mercadoriasDefeitosService.get(null, { "id_mercadoria": this.classificacao.id_mercadoria })
        .subscribe(data => {
          this.listDefeitos = data['Payload'];
        },
          error => {
            this.func.showErro(error.json());
          });
    }
  }

  voltar() {
    const idMercadoria = this.route.snapshot.queryParams["mercadoria"] || this.classificacao.id_mercadoria;
    if (idMercadoria) {
      this.router.navigate(['/painel', 'mercado-interno-mercadorias', idMercadoria, 'upd'], { queryParams: { abaindices: '1' } });
    } else {
      this._location.back();
    }
  }

  save() {
    this.enviandoForm = true;
    let result,
      values = this.form.value;

    if (values.nome) {
      values.nome = values.nome.toUpperCase();
    }

    if (values.id) {
      result = this.mercadoriasClassificacaoService.editar(values, values.id);
    } else {
      result = this.mercadoriasClassificacaoService.adicionar(values);
    }

    const idMercadoria = this.route.snapshot.queryParams["mercadoria"] || values.id_mercadoria || this.classificacao.id_mercadoria;

    result.subscribe(data => {
      if (idMercadoria) {
        this.router.navigate(['/painel', 'mercado-interno-mercadorias', idMercadoria, 'upd'], { queryParams: { abaindices: '1' } });
      } else {
        this.router.navigate(['/painel', 'mercado-interno-mercadorias', 'classificacao']);
      }
    },
      error => {
        this.enviandoForm = false;
        this.func.showErro(error.json());
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/mercado-interno-mercadorias/mercado-interno-classificacao-form.component.ts